export enum StatusEnum {
    AWAITING = 1,
    IN_PROGRESS = 2,
    FINISHED = 3,
    PAUSED = 4,
    CANCELLED = 5
}
